import React, { useState } from "react";
// import { Editor } from "react-draft-wysiwyg";
import "draft-js/dist/Draft.css";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { Button } from "react-bootstrap";
import { ErrorMessage, Form, Formik } from "formik";
import { sendEmailValidationSchema } from "./Validation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDownload,
  faPlus,
  faXmarkCircle,
} from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import EmailChipsInput from "./EmailChipsInput";

const SendEmailAttach = ({
  handleSubmit,
  setFiles,
  files,
  toggleCancel,
  // handleEditorChange,
  // editorState,
  mailData,
  type,
}) => {
  // Handle file addition
  const handleAddFiles = (event) => {
    const files = Array.from(event.target.files);
    // setFiles((prevAttachments) => [...prevAttachments, ...files]);
    const invalidFiles = files.filter(
      (file) => !allowedFileTypes.includes(file.type)
    );

    if (invalidFiles.length > 0) {
      toast.error(
        `Invalid file type(s): ${invalidFiles
          .map((file) => file.name)
          .join(
            ", "
          )}. Please upload PDF, images, Word, Excel, or CSV files only.`
      );
    } else {
      setFiles((prev) => [...prev, ...files]);
    }
  };

  // Handle file removal
  const handleRemoveFile = (fileIndex) => {
    setFiles((prevAttachments) =>
      prevAttachments.filter((_, index) => index !== fileIndex)
    );
  };

  const [ccShow, setCCShow] = useState(mailData?.cc?.length > 0 ? true : false);
  const [bccShow, setBCCShow] = useState(false);

  const toggleCCShow = () => {
    setCCShow(!ccShow);
  };

  const toggleBCCShow = () => {
    setBCCShow(!bccShow);
  };

  const allowedFileTypes = [
    "application/pdf",
    "image/jpeg",
    "image/png",
    "image/gif",
    "image/bmp",
    "application/msword", // .doc
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
    "application/vnd.ms-excel", // .xls
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
    "text/csv", // .csv
  ];

  const handleDownload = async (export_report_path) => {
    try {
      if (export_report_path) {
        var a = document.createElement("a");
        a.href = export_report_path;
        var file = export_report_path.split("/");
        a.setAttribute("download", file[file.length - 1] || "file.pdf");
        a.setAttribute("target", "_blank");
        document.body.appendChild(a);
        a.click();
        a.remove();
      }
    } catch (e) {
      const errors = e.response?.data?.errors;
      Object.keys(errors).forEach((key) => {
        toast.error(errors[key][0]);
      });
    }
  };

  return (
    <Formik
      initialValues={{
        email: mailData?.email ? mailData?.email : "",
        cc: mailData?.cc ? mailData?.cc : "",
        bcc: "",
        ccChip: "",
        bccChip: "",
        subject: mailData?.subject ? mailData?.subject : "",
        // message: "",
      }}
      validationSchema={sendEmailValidationSchema}
      onSubmit={(values) => handleSubmit(values)}
    >
      {({ setFieldValue, handleChange, handleBlur, values }) => (
        <Form className="entry-section email-form">
          <div className="form-box">
            <div className="form-group full-width">
              <label className="email-label">
                <div>
                  <span className="required">*</span>To
                </div>
                <div className="options-email">
                  <span
                    className={ccShow && "active"}
                    onClick={() => toggleCCShow()}
                  >
                    Cc
                  </span>
                  <span
                    className={bccShow && "active"}
                    onClick={() => toggleBCCShow()}
                  >
                    Bcc
                  </span>
                </div>
              </label>
              <input
                type="email"
                name="email"
                className="form-control"
                placeholder="Enter recipient email"
                value={values?.email ? values?.email : ""}
                onChange={handleChange}
                autoComplete="off"
                onKeyPress={(e) => {
                  e.which === 13 && e.preventDefault();
                }}
              />
              <div className="text-danger error-message">
                <ErrorMessage name="email" />
              </div>
            </div>

            {ccShow && (
              // <div className="form-group full-width">
              //   <label>CC</label>
              //   <input
              //     type="text"
              //     name="cc"
              //     className="form-control"
              //     placeholder="Enter CC email"
              //     value={values?.ccChip ? values?.ccChip : ""}
              //     onChange={handleChange}
              //     autoComplete="off"
              //     onKeyPress={(e) => {
              //       e.which === 13 && e.preventDefault();
              //     }}
              //   />
              //   <div className="text-danger error-message">
              //     <ErrorMessage name="ccChip" />
              //   </div>
              // </div>
              <div className="form-group full-width">
                <EmailChipsInput
                  label="CC"
                  onEmailsChange={(emails) =>
                    setFieldValue("cc", emails.join(","))
                  }
                  placeholder="Enter CC and Press Comma or Enter"
                  setFieldValue={setFieldValue}
                  keyData="ccChip"
                  value={values?.ccChip ? values?.ccChip : ""}
                  chipValue={values?.cc ? values?.cc : []}
                />
                <div className="text-danger error-message">
                  <ErrorMessage name="ccChip" />
                </div>
              </div>
            )}

            {bccShow && (
              // <div className="form-group full-width">
              //   <label>BCC</label>
              //   <input
              //     type="text"
              //     name="bcc"
              //     className="form-control"
              //     placeholder="Enter BCC email"
              //     value={values?.bcc ? values?.bcc : ""}
              //     onChange={handleChange}
              //     autoComplete="off"
              //     onKeyPress={(e) => {
              //       e.which === 13 && e.preventDefault();
              //     }}
              //   />
              //   <div className="text-danger error-message">
              //     <ErrorMessage name="bcc" />
              //   </div>
              // </div>
              <div className="form-group full-width">
                <EmailChipsInput
                  label="BCC"
                  onEmailsChange={(emails) =>
                    setFieldValue("bcc", emails.join(","))
                  }
                  setFieldValue={setFieldValue}
                  keyData="bccChip"
                  placeholder="Enter BCC and Press Comma or Enter"
                  value={values?.bccChip ? values?.bccChip : ""}
                />
                <div className="text-danger error-message">
                  <ErrorMessage name="bccChip" />
                </div>
              </div>
            )}

            <div className="form-group full-width">
              <label>
                <span className="required">*</span>Subject
              </label>
              <input
                type="text"
                name="subject"
                value={values?.subject ? values?.subject : ""}
                onChange={handleChange}
                placeholder="Enter Subject"
                onBlur={handleBlur}
                autoComplete="off"
                onKeyPress={(e) => {
                  e.which === 13 && e.preventDefault();
                }}
              />

              <span className="text-danger error-message">
                <ErrorMessage
                  name="subject"
                  component="div"
                  className="text-danger"
                />
              </span>
            </div>

            {/* <div className="form-group full-width message-input">
              <label>
                <span className="required">*</span>Message
              </label>
              <Editor
                editorState={editorState}
                toolbar={{
                  inline: {
                    options: ["bold", "italic", "underline"],
                  },
                  options: [
                    "inline",
                    // 'blockType',
                    "fontSize",
                    "list",
                    "textAlign",
                    "remove",
                    "history",
                  ],
                }}
                onEditorStateChange={handleEditorChange}
                wrapperClassName="wrapper-class"
                editorClassName="editor-class"
                toolbarClassName="toolbar-class"
              />
            </div> */}
            <div className="form-group full-width">
              <div className="attachment-button">
                <input
                  type="file"
                  className="form-control"
                  multiple
                  onChange={handleAddFiles}
                  accept=".pdf, image/*, .xls, .xlsx, .doc, .docx, .csv"
                  style={{ display: "none" }}
                  id="file-input"
                />
                <Button
                  variant="outline-primary"
                  onClick={() => document.getElementById("file-input").click()}
                >
                  <FontAwesomeIcon icon={faPlus} /> Attachment
                </Button>
              </div>
              {(files.length > 0 || mailData?.file) && (
                <div className="file-list-tags">
                  {mailData?.file && (
                    <div
                      className="tag"
                      onClick={() => handleDownload(mailData?.file)}
                      style={{
                        cursor: "pointer",
                      }}
                    >
                      <span>
                        {type === "payment"
                          ? "Payment Advice"
                          : type === "payment_schedule"
                          ? "Payment Schedule"
                          : type === "aba"
                          ? "ABA File"
                          : type === "receipt"
                          ? "Receipt"
                          : type === "subcontractor"
                          ? "Notice"
                          : "Default"}
                      </span>
                      <FontAwesomeIcon icon={faDownload} />
                    </div>
                  )}
                  {files.map((file, index) => (
                    <div key={index} className="tag">
                      <span title={file.name}>{file.name}</span>
                      <FontAwesomeIcon
                        icon={faXmarkCircle}
                        onClick={() => handleRemoveFile(index)}
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className="email-form-footer">
              <Button type="submit" variant="primary">
                Send Email
              </Button>
              <Button
                variant="secondary"
                className="cancel-btn"
                onClick={() => toggleCancel()}
              >
                Cancel
              </Button>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default SendEmailAttach;
